module.exports = __webpack_public_path__ + "static/media/27459313_1966554483608314_2700168222056784694_n.ea520fa1.jpg";